import React from 'react'
import styled from "styled-components"
interface auto_props {
  anim: boolean
}


export const Wrapper = styled.div<auto_props>`
/* display: flex; */
/* flex-direction: column; */
/* justify-content: center; */
/* align-items: center; */
  padding: 24px 30px;
  width: 100%;
  height: 466px;
  border-radius: 20px;
  background: rgba(48, 30, 86, 0.85);
  text-align: center;
  overflow: hidden;
  animation: "appear";
   animation-duration: 0.167s;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-fill-mode: forwards;
  article {
    display: flex;
    justify-content: center;
    align-items: center;
      margin-top:10px;
      font-size: 18px;
      
      p{
        width: 30%;
        cursor: pointer;
      }
    }
  .auto-wrapper {
    width: 100%;
    padding: 15px;
    animation: ${({ anim }) => (anim ? "disAappearContent" : "appearContent")};
    transform-origin: top;
    animation-duration: 0.167s;
    animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
    animation-fill-mode: forwards;
    svg {
      path {
        fill: #171731;
      }
    }
    span {
      width: 174px;
    }
    input {
      width: 100%;
    }
    p {
      margin-top:10px;
      font-size: 18px;
    }
    @keyframes appearContent {
      0%,
      50% {
        opacity: 0;
      height: 200px;

      }
      100% {
        opacity: 1;
      height: 466px;

      }
    }
    @keyframes disAappearContent {
      0% {
        opacity: 1;
      height: 466px;

      }
      100% {
        opacity: 0;
      height: 200px;

      }
    }
  }


`


const PairWrapper = styled.section`
text-align: center;
margin-bottom: 18px;
/* height: 86px; */
div{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 276px;
  height: 56px;
  border: 3px solid #FFB000;
  border-radius: 50px;
  margin-top: 11px;

p {
  font-size: 18px;
    color: #ffbb00;
    justify-content: center;
    align-items: center;
         display: flex;
}

.infinite {
    position: absolute;
     width: 28px;
     pointer-events: none;
  }

}
`

interface pair_props {
  name: string
  children: any
}
export function Pair({ name, children }: pair_props) {
  return (
    <PairWrapper>
      <p>{name}</p>
      <div>
        {children}
      </div>
    </PairWrapper>

  )
}
